export default function seed() {
    return 'seed'
}